import controller from './masterpass-info-dialog.controller';
import './masterpass-info-dialog.less'

export default {
  controller,
  template: require('./masterpass-info-dialog.html')
};



// WEBPACK FOOTER //
// src/app/buy/masterpass-info-dialog/masterpass-info-dialog.component.ts